<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: white;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainerEmpty" id="videoContainerEmpty" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <div id="bkgrdVideoOverlay" :style="{ height: videoHeight + 'px' }"></div>
        </div>
      </div>
      <div class="body-overall page-top fonts" style="color:black!important;">
          <v-row class="textPanel">
              <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs pb-6">
                    <v-col cols="12" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">CONTACT</h1>
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0 pb-6">
                        <h1 class="font2-heada" style="color:black!important;">CONTACT</h1>
                  </v-row>
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
              </div>
          </v-row>  
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pb-4 pt-0 mt-0">
                        <span v-if="!emailSent" class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                              Please fill out the form below and we will get back to you as soon as possible. 
                        </span>
                      </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <div v-if="!emailSent">
                  <form ref="contactForm" @submit.prevent="sendEmail">
                    <v-row justify="start" class="pl-12 pr-12">
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="form.email"
                          label="Your Email"
                          name="email"
                          type="email"
                          class="custom-text-field"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="form.subject"
                          label="Subject"
                          name="subject"
                          type="text"
                          class="custom-text-field"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="form.message"
                          label="Message"
                          name="message"
                          type="text"
                          class="custom-text-field"
                          required
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          v-model="form.attachment"
                          label="Attachment (max 2MB), only .pdf files accepted"
                          name="attachment"
                          type="file"
                          class="custom-text-field"
                          accept=".pdf"
                        ></v-file-input>
                      </v-col>
                      <v-col cols="12" align="center" class="pb-4">
                        <v-btn v-if="!isSending" :disabled="attachmentError != ''" text plain :ripple="false" elevation="0" class="text-none nomenu-btn-page" type="submit" color="primary">Send</v-btn>
                        <v-progress-circular v-else indeterminate color="black"></v-progress-circular>
                      </v-col>
                    </v-row>
                    <v-row v-if="attachmentError" justify="center" class="pl-12 pr-12 pb-0 pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:red!important;">
                          {{ attachmentError }}
                        </span>
                      </v-row>
                    <v-row v-if="emailError" justify="center" class="pl-12 pr-12 pb-0 pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:red!important;">
                          Email Sent Error
                        </span>
                    </v-row>  
                  </form>
                </div>
                <div v-else>
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-4 pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:green!important;">
                          Email Sent
                        </span>
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-4 pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Thank you for contacting us. We will get back to you as soon as possible.
                        </span>
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                      <v-row justify="center" class="pl-12 pr-12 pb-12 pt-12 pt-0 mt-0">
                      </v-row>  
                </div>
              </div>
            </v-row>
      </div>
      <div class="body-overall page-top fonts" style="color:black!important;">
          <v-row class="textPanel">
              <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
              </div>
          </v-row>  
      </div>
      <div class="body-overall fonts">
          <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';
import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'Contact',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    form: {
        email: '',
        subject: '',
        message: '',
        attachment: null
      },
    emailSent: false,
    emailError: false,
    isSending: false,
    attachmentError: '',
    videoHeight: 1000 // Initial height of the video
  }),
  mounted() {  
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {
    this.emailSent = false;
    this.emailError = false;
    this.form.attachment = null;
    this.attachmentError = '';
  }, 
  watch: {
    'form.attachment'(newVal) {
      if (!newVal) {
        this.attachmentError = '';
      } else if (newVal.size > 2 * 1024 * 1024) {
        this.attachmentError = 'Attachment size exceeds the 2MB limit.';
      } else {
        this.attachmentError = '';
      }
    }
  },
  methods: {
    sendEmail() {
      // Check if attachment size exceeds 2MB
      if (this.form.attachment && this.form.attachment.size > 2 * 1024 * 1024) {
        this.attachmentError = 'Attachment size exceeds the 2MB limit.';
        return;
      }

      this.isSending = true;

      const serviceID = 'service_ng0gbar';
      const templateID = 'template_e18xwu2';

      emailjs.sendForm(serviceID, templateID, this.$refs.contactForm, 'pCOXh57qKWTGa5hfZ',
        )
        .then((response) => {
          this.emailError = false;
          this.emailSent = true;
          this.isSending = false;
        }, (error) => {
          this.emailError = true;
          this.isSending = false;
        });
    },
    handleScroll() {
      if (!this.drawerham){
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;
      }
    },
    handleClickVideo(link){
      if (link) {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },
    getPicture(img){
        return '';
    },
  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';
@use './css/styles_finance.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

#videoContainerEmpty {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}


.body-overall {
  background-color: white !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}

.custom-text-field {
  color: black;
  background-color: white;
  border: 0px solid black;
  border-radius: 10px;
}

.custom-text-field .v-input__control .v-input__slot {
  color: white;
}

.custom-text-field .v-input__control {
  background-color: white!important;
}

.custom-text-field .v-label {
  color: white !important;
}

.nomenu-btn-page {
  color: black!important;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  box-shadow: none !important;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}

.nomenu-btn-page:disabled {
  color: grey!important;
  background-color: transparent !important;
  transition: none;
}

.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay {
  opacity: 0;
}

.nomenu-btn-link {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}


</style>

